export const sizeParams = {
    tiny: {
        width: "7px",
        height: "7px",
        gap: "2px",
    },
    small: {
        width: "9px",
        height: "9px",
        gap: "2px",
    },
    standard: {
        width: "10px",
        height: "10px",
        gap: "4px",
    },
    big: {
        width: "14px",
        height: "14px",
        gap: "4px",
    },
    huge: {
        width: "21px",
        height: "21px",
        gap: "6px",
    },
};
export function rorateArray(arr, rotations) {
    for (let index = 1; index < rotations; index += 1) {
        const element = arr.pop();
        arr.unshift(element);
    }
    return arr;
}
